<template>
  <div id="link-hero-section">
    <div class="row banner-section align-items-center text-center">
      <div class="col">
        <a target="_blank" href="https://restaurantguru.com/Casa-Muyo-Barcelona">
          <img :src="require(`../../assets/img/guru/2.png`)"
            alt="Restaurante Casa Muyo - Award Winner at Restaurant Guru" class="banner-section__image" />
        </a>
        <h1 class="font-4 color-5 banner-title">Restaurante Casa Muyo</h1>
        <p class="font-3 color-5 banner-sub-title">FOUNDED IN 1964</p>
        <p class="font-4 color-3 banner-sub-title">Desayuno, Menu del dia, Carta</p>
        <div class="reservation-call-to-action moveTop">
          <div>
            <a href="tel:+34-932-31-77-16" class="reserve-button font-3"><i class="fas fa-phone" aria-hidden="true"></i>
              {{ callUsText }}</a>
          </div>
          <div>
            <a target="_blank" href="https://wa.me/+34631810727" class="reserve-button font-3"><i
                class="fab fa-whatsapp"></i> Whatsapp</a>
          </div>
          <div>
            <a target="_blank" href="mailto:casamuyorestaurante@gmail.com" class="reserve-button font-3"><i
                class="fa fa-envelope"></i>{{ emailUsText }}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HeroImage",
  data: function () {
    return {}
  },
  components: {},
  computed: {
    callUsText: function () {
      return this.$store.getters.currentData.reservations.callUs
    },
    emailUsText: function () {
      return this.$store.getters.currentData.reservations.emailUs
    }
  }
}
</script>

<style lang="scss">
.banner-section {
  height: 65vh;

  &__image {
    border-radius: 50%;
    height: 100px;
    width: 100px;

    @media screen and (min-width: 960px) {
      height: 150px;
      width: 150px;
    }
  }
}

.banner-title {
  text-shadow: 1px 1px 2px #ff0000;
  font-size: 35px;
  animation: moveLeft 2s ease-out;
}

.banner-sub-title {
  font-size: 20px;
  font-weight: bolder;
  letter-spacing: 0.2em;
  text-shadow: 1px 1px 2px #a42e0e;
  animation: moveRight 2s ease-out;
}

#link-hero-section {
  background-image: url("../../assets/img/casamuyowall.jpg");
  background-position: center;
  background-attachment: fixed;
  background-repeat: no-repeat;
  background-size: cover;
  padding-right: 20px;
  padding-left: 20px;
}

@keyframes moveLeft {
  0% {
    opacity: 0;
    transform: translateX(-50px);
  }

  80% {
    transform: translateX(20px);
  }

  100% {
    opacity: 1;
    transform: translate(0);
  }
}

@keyframes moveRight {
  0% {
    opacity: 0;
    transform: translateX(50px);
  }

  80% {
    transform: translateX(-20px);
  }

  100% {
    opacity: 1;
    transform: translate(0px);
  }
}

@media screen and (min-width: 960px) {
  .banner-title {
    font-size: 43px;
  }

  .banner-sub-title {
    font-size: 23px;
  }

  .banner-section {
    height: 75vh;
  }
}

.reserve-button {
  margin: 10px;
  font-weight: bold;
  color: black;
  letter-spacing: 2px;
  background-color: orange;
  padding: 0.375rem 0.75rem;
  border-radius: 0.25rem;
  user-select: none;
  text-decoration: none !important;

  @media screen and (min-width: 960px) {
    padding: 0.5rem 1rem;
    border-radius: 0.3rem;
  }
}

.reservation-call-to-action {
  margin-top: 16px;
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.reservation-call-to-action>div {
  padding: 5px;
}

.reserve-button:hover {
  background-color: gold;
}

@keyframes pulse {
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(1.1);
  }

  100% {
    transform: scale(1);
  }
}

.guru-image {
  margin: auto;
  animation: pulse 1s infinite;
}

.moveTop {
  animation: moveTop 1.5s ease-out;
}

@keyframes moveTop {
  0% {
    opacity: 0.2;
    transform: translateY(50px);
  }

  80% {
    opacity: 0.7;
    transform: translateY(-10px);
  }

  100% {
    opacity: 1;
    transform: translate(0px);
  }
}
</style>
